import React from 'react';
import styled, { keyframes } from 'styled-components';

const animateProgressBar = keyframes`
  0% { width: 0%; }
  50% { width: 40%; }
  70% { width: 80%; }
  100% { width: 100%; }
`;


const ProgressBarContainer = styled.div`
  width: 100%;
  max-width: 330px;
  height: 9px;
  background-color: ${(props) => props.theme.colors.colorInactiveProgress};
  border-radius: 6px;
  margin-top: 16px;
`;

const ProgressBarFiller = styled.div`
  height: 100%;
  border-radius: inherit;
  background-color: ${(props) => props.theme.colors.colorPrimary};
  animation: ${animateProgressBar} 10s linear;
`;

const AppLinearProgressBar = () => {
  return (
    <ProgressBarContainer>
      <ProgressBarFiller />
    </ProgressBarContainer>
  );
};

export default AppLinearProgressBar;